import { render, staticRenderFns } from "./NuevaCategoria.vue?vue&type=template&id=48d52120&"
import script from "./NuevaCategoria.vue?vue&type=script&lang=js&"
export * from "./NuevaCategoria.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports